import React, { useEffect, useState } from "react";
import {
  StyledDivPositionFlex,
  StyledEmptyCard,
  StyledSelectContent,
  StyledSelectWrapper,
  StyledSpinnerWrapper,
} from "../styles/styledComponents";
import RadioGroup from "./RadioGroup";
import Card from "./Card";
import "../styles/selectWrapper.css";
import colors from "../styles/colors";
import { useSelectedContextState } from "../context/selectedContext";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import CheckIcon from "./CheckIcon";

type RadioSelectWrapperProps = {
  header: string;
  radioValues: any[];
  selected: (value: string) => any;
  clickNext: () => any;
  setFirstDefaultValue?: boolean;
  type: string;
};

const RadioSelectWrapper = (props: RadioSelectWrapperProps) => {
  const {
    header,
    radioValues,
    selected,
    clickNext,
    setFirstDefaultValue,
    type,
  } = props;
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedObject, setSelectedObject] = useState<any>(null);

  const [state] = useSelectedContextState();
  const { clearAll, productLoading, mountingLoading, clearChildrenStates } =
    state;
  const { t } = useTranslation("trans");


  const onSelected = (value: any) => {
    setSelectedValue(value);
    let obj = radioValues.filter((x) => x.id.toString() === value.toString());
    setSelectedObject(obj[0]);
    selected(value);
  };

  useEffect(() => {
    if (clearAll || (clearChildrenStates && type.toLowerCase() !== "product")) {
      setSelectedValue("");
      setSelectedObject(null);
    }
  }, [clearAll, clearChildrenStates, type]);

  return (
 
      <StyledSelectWrapper
        className={selectedValue ? "triangleSelected" : "triangleUnSelected"}
        style={{
          background: selectedValue ? colors.selectedBg : colors.unSelectedBg,
          borderColor: selectedValue
            ? colors.selectedBorder
            : colors.unSelectedBorder,
        }}
      >
        <StyledSelectContent
          role="radiogroup"
          aria-labelledby={type + "header"}
        >
          <h2 id={type + "header"}>
            {header}
            <CheckIcon size="sm" display={selectedValue !== ""} />
          </h2>
          <StyledDivPositionFlex>
            {(type.toUpperCase() === "PRODUCT" && productLoading) ||
            (type.toUpperCase() === "MOUNT" && mountingLoading) ? (
              <StyledSpinnerWrapper>
                <CircularProgress color="inherit" />
                {t("loading")}
              </StyledSpinnerWrapper>
            ) : (
              <RadioGroup
                type={type}
                selected={onSelected}
                radioValues={radioValues}
                setFirstDefaultValue={setFirstDefaultValue}
              />
            )}
            {selectedValue ? (
              <Card
                title={selectedObject?.name.toString().toUpperCase()}
                text={selectedObject?.description || ""}
                imgUrl={
                  selectedObject?.imageUrl || ""
                }
              />
            ) : (
              <StyledEmptyCard>
                {type.toLowerCase() === "product"
                  ? <p>{t("cardChoose.product").toUpperCase()}</p>
                  : <p>{t("cardChoose.mount").toUpperCase()}</p>
            }
              </StyledEmptyCard>
            )}
          </StyledDivPositionFlex>
          
        </StyledSelectContent>
      </StyledSelectWrapper>

  );
};

export default RadioSelectWrapper;
